import { useGLTF } from '@react-three/drei';
import { useMemo } from 'react';

import type { Object3D } from 'three';

interface ClonedGLTFProps {
    gltfUrls: string[];
}

interface GLTF {
    scene: Object3D;
}

export const useLoadClonedGLTF = ({ gltfUrls }: ClonedGLTFProps) => {
    const gltfs = useGLTF(gltfUrls) as GLTF[];

    const clonedGLTFs = useMemo(() => {
        if (!gltfs || gltfs.length === 0) {
            return null;
        }

        return gltfs.map((gltf) => {
            return gltf.scene.clone(true);
        });
    }, [gltfs]);

    return clonedGLTFs;
};
